declare let React: any

// Route pubblica: /demo
// Redirect immediato alla pagina HTML standalone con il nuovo engine open source 8th Wall.
// Bypassa completamente React, AFrameScene e lo stack XR8 con API key.
const DemoARExperience = () => {
    React.useEffect(() => {
        window.location.replace('/ar-demo.html')
    }, [])
    return null
}

export { DemoARExperience }
